<template>
	<div class="content-wrapper">
		<!-- Content -->
		<div class="container-xxl flex-grow-1 container-p-y">
			<!-- Sticky Actions -->
			<div class="row">
				<div class="col-12">
					<div class="card">
						<div
							class="card-header sticky-element bg-label-secondary d-flex justify-content-sm-between align-items-sm-center flex-column flex-sm-row">
							<h5 class="card-title mb-sm-0 me-2">{{ $t('employees.create.title') }}</h5>
						</div>
						<div class="card-body">
							<div class="row">
								<div class="col-lg-8 mx-auto">

								<!-- 2. Delivery Type -->
									<h5 class="my-6">{{ $t('employees.create.accountType') }}</h5>
									<div class="row gy-3">
										<div class="col-md">
											<div class="form-check custom-option custom-option-icon">
												<label class="form-check-label custom-option-content" for="customRadioIcon1">
													<span class="custom-option-body">
														<i class="ri-user-line"></i>
														<span class="custom-option-title mb-2"> {{ $t('common.roles.trainee') }} </span>
														<small> {{ $t('employees.create.traineeDescription') }} </small>
													</span>
													<input
														name="customDeliveryRadioIcon"
														class="form-check-input"
														type="radio"
														value="trainee"
														id="customRadioIcon1"
														v-model="form.role"
														checked />
												</label>
											</div>
										</div>
										<div class="col-md" v-if="displayConsultants">
											<div class="form-check custom-option custom-option-icon">
												<label class="form-check-label custom-option-content" for="customRadioIcon2">
													<span class="custom-option-body">
														<i class="ri-group-2-fill"></i>
														<span class="custom-option-title mb-2"> {{ $t('common.roles.consultant') }} </span>
														<small>
															{{ $t('employees.create.consultantDescription') }}
														</small>
													</span>
													<input
														name="customDeliveryRadioIcon"
														class="form-check-input"
														type="radio"
														value="consultant"
														id="customRadioIcon2"
														v-model="form.role"
													/>
												</label>
											</div>
										</div>
										<div class="col-md">
											<div class="form-check custom-option custom-option-icon">
												<label class="form-check-label custom-option-content" for="customRadioIcon3">
													<span class="custom-option-body">
														<i class="ri-vip-crown-line"></i>
														<span class="custom-option-title mb-2"> {{ $t('common.roles.manager') }} </span>
														<small> {{ $t('employees.create.managerDescription') }}</small>
													</span>
													<input
														name="customDeliveryRadioIcon"
														class="form-check-input"
														type="radio"
														value="manager"
														id="customRadioIcon3"
														v-model="form.role"
													/>
												</label>
											</div>
										</div>
									</div>
									<hr />
									<!-- 1. Delivery Address -->
									<h5 class="mb-4">{{ $t('employees.create.infoTitle') }}</h5>

									<div class="row g-6">
										<div class="col-md-6">
											<div class="form-floating form-floating-outline">
												<input type="text" id="fullname" class="form-control" placeholder="John Doe" v-model="form.firstName" />
												<label for="fullname">{{ $t('common.fields.firstName') }}</label>
												<small v-if="errors.firstName" class="text-danger">{{ errors.firstName }}</small>
											</div>
										</div>
										<div class="col-md-6">
											<div class="form-floating form-floating-outline">
												<input type="text" id="fullname" class="form-control" placeholder="John Doe" v-model="form.lastName" />
												<label for="fullname">{{ $t('common.fields.lastName') }}</label>
												<small v-if="errors.lastName" class="text-danger">{{ errors.lastName }}</small>
											</div>
										</div>
										<div class="col-md-6">
											<div class="input-group input-group-merge">
												<div class="form-floating form-floating-outline">
													<input
														class="form-control"
														type="text"
														id="email"
														name="email"
														placeholder="john.doe"
														aria-label="john.doe"
														aria-describedby="email3"
														v-model="form.email"
													/>
													<label for="email">{{ $t('common.fields.email') }}</label>
													<small v-if="errors.email" class="text-danger">{{ errors.email }}</small>
												</div>
											</div>
										</div>
										<div class="col-md-6">
											<div class="form-floating form-floating-outline">
												<input 
													type="text"
													id="bs-datepicker-basic"
													placeholder="DD/MM/YYYY"
													class="form-control"
													ref="birthDate"
													@input="handleDateInput"
													v-model="form.birthDate"
												/>
												<label for="bs-datepicker-basic">{{ $t('common.fields.birthDate') }}</label>
												<small v-if="errors.birthDate" class="text-danger">{{ errors.birthDate }}</small>
											</div>
										</div>
										<div class="col-12">
											<div class="input-group input-group-merge">
												<div class="form-floating form-floating-outline">
													<input
														type="text"
														id="socialSecurityNumber"
														class="form-control"
														placeholder="1 85 05 78 006 084 36"
														autocomplete="off"
														@input="handleSsnInput"
														v-model="form.socialSecurityNumber"
													/>
													<label for="socialSecurityNumber">{{ $t('common.fields.socialSecurityNumber') }}</label>
													<small v-if="errors.socialSecurityNumber" class="text-danger">{{ errors.socialSecurityNumber }}</small>
												</div>
												<span class="input-group-text" data-bs-toggle="tooltip" :data-bs-title="$t('employees.ssnInfo')">
													<i class="ri-information-line"></i>
												</span>
											</div>
										</div>
									</div>

									<div class="row g-6 mt-2" v-if="displayEntityName">
										<div class="col-12">
											<div class="form-floating form-floating-outline">
												<input type="text" id="entityName" class="form-control" placeholder="Nom de l'entité" v-model="form.entityName" />
												<label for="entityName">{{ $t('common.fields.entityName') }}</label>
											</div>
										</div>
									</div>
									<hr />

									<!-- DISPLAY AGENCIES -->
									<h5 class="mb-4" v-if="displayAgencies">{{ $t('employees.create.agencyTitle') }}</h5>

									<div class="row gy-3" v-if="displayAgencies">
										<div class="col-md">
											<div class="form-check custom-option custom-option-icon">
												<select id="defaultSelect" class="form-select" v-model="form.agency">
													<option disabled value="" selected>{{ $t('employees.create.selectAgency') }}</option>
													<option v-for="agency in agencies" :key="agency" :value="agency">
														{{ agency }}
													</option>
												</select>
											</div>
										</div>
									</div>

									<hr  v-if="displayAgencies" />
								</div>
							</div>
						</div>
					</div>
					<div
						class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-6 row-gap-4">
						<div class="d-flex flex-column justify-content-center">
							
						</div>
						<div class="d-flex align-content-center flex-wrap gap-4 mt-5">
							<router-link to="/employees/list">
								<button class="btn btn-outline-secondary">{{ $t('common.actions.back') }}</button>
							</router-link>
							<button type="submit" class="btn btn-primary" @click="createEmployee()">{{ $t('employees.create.submitButton') }}</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import HTTP from "@/axios";

import { Tooltip } from 'bootstrap'
import { formatNIR, isValidNIR, normalizeNIR } from "@/helpers/nir";

export default {
	name: "CreateEmployee",

	data() {
		return { 
			form: {
				firstName: "",
				lastName: "",
				email: "",
				birthDate: null,
				role: "trainee",
				agency: "",
				entityName: "",
				socialSecurityNumber: ""
			},
			agencies: [],
			displayAgencies: false,
			displayConsultants: false,
			displayEntityName: false,
			errors: {},
		};
	},

	methods: {
		handleDateInput(event) {
			let input = event.target.value;

			// Enlever tous les caractères non numériques
			input = input.replace(/\D/g, '');

			// Formatage automatique en DD/MM/YYYY
			if (input.length <= 2) {
				this.form.birthDate = input;
			} else if (input.length <= 4) {
				this.form.birthDate = `${input.slice(0, 2)}/${input.slice(2)}`;
			} else {
				this.form.birthDate = `${input.slice(0, 2)}/${input.slice(2, 4)}/${input.slice(4, 8)}`;
			}
		},

		clearError(field) {
			// Supprime l'erreur pour le champ spécifié
			if (this.errors[field]) {
				delete this.errors[field];
			}
		},

		validateForm() {
			this.errors = {};

			if (!this.form.firstName) {
				this.errors.firstName = this.$t('validation.requiredFirstName');
			}
			if (!this.form.lastName) {
				this.errors.lastName = this.$t('validation.requiredLastName');
			}
			if (!this.form.email || !this.validateEmail(this.form.email)) {
				this.errors.email = this.$t('validation.invalidEmail');
			}

			if (!this.form.birthDate)
				this.errors.birthDate = this.$t('validation.requiredBirthDate');

			if (this.form.socialSecurityNumber && !isValidNIR(this.form.socialSecurityNumber))
				this.errors.socialSecurityNumber = this.$t('validation.invalidSocialSecurityNumber');

			return Object.keys(this.errors).length === 0;
		},

		handleSsnInput(event) {
			this.form.socialSecurityNumber = formatNIR(event.target.value);
		},

		validateEmail(email) {
			const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
			return re.test(email);
		},

		async fetchFeaturesFlags() {
			try {
				const response = await HTTP.get('/company/flags');
				this.displayAgencies = response.data.displayAgencies;
				this.displayConsultants = response.data.displayConsultants;
				this.displayEntityName = response.data.displayEntityName;
				this.agencies = response.data.agencies;
			} catch (error) {
				// Récupérer le message d'erreur de l'API ou définir un message par défaut
				const errorMessage = error?.response?.data?.message || this.$t('errors.generic');

				alert(errorMessage);

				// Log détaillé dans la console (utile en développement)
				console.error("Erreur API:", error);
			}
		},

		async createEmployee() {
			const validated = this.validateForm();

			if (!validated)
				return;

			if (this.displayAgencies && !this.form.agency)
				return alert(this.$t('validation.requiredAgency'))

			if (!this.displayAgencies)
				this.form.agency = null;

			if (!this.form.birthDate)
				delete this.form.birthDate;

			if (this.form.socialSecurityNumber)
				this.form.socialSecurityNumber = normalizeNIR(this.form.socialSecurityNumber);
			else
				delete this.form.socialSecurityNumber;

			try {
				await HTTP.post('/company/employees/create', this.form);
				this.$router.push("/employees/list");
			} catch (error) {
				// Récupérer le message d'erreur de l'API ou définir un message par défaut
				const errorMessage = error?.response?.data?.message || this.$t('errors.generic');

				alert(errorMessage);

				// Log détaillé dans la console (utile en développement)
				console.error("Erreur API:", error);
			}
		}
	},

	async mounted() {
		await this.fetchFeaturesFlags();

		const tooltipTriggerList = this.$el.querySelectorAll('[data-bs-toggle="tooltip"]')
		tooltipTriggerList.forEach((el) => {
			new Tooltip(el)
		})
	}
};
</script>

<style scoped>
/* Ajoutez des styles spécifiques à la page Dashboard */
.dashboard {
	padding: 1rem;
}

.card-title {
	font-size: 1.2rem;
}

.card-text {
	margin: 0;
}
</style>
